exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html {\n  font-family: \"Helvetia\", \"Arial\", sans-serif;\n  background-color:#E5E5E1;\n}\n\nbody {\n  /* Show it is fixed to the top */\n  min-height: 75rem;\n  padding-top: 4.5rem;\n}\n\n.header {\n  font-size: 2em;\n  margin-top: 1%;\n  margin-bottom: 1%;\n  position: fixed;\n}\n\n.footer {\n  clear: both;\n  padding: 0 15px;\n}\n\n/* to verify - orphan class*/\n.priceRef {\n  display: block;\n}\n\n.exchanges{\n  width: 40%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader!./app/css/main.css
// module id = 243
// module chunks = 0